import {
  ConstellationIcon,
  OfficeBuildingIcon,
  ParagraphLongIcon,
  ParagraphShortIcon,
  SmileIcon,
} from '../../icons';
import { LoadingButton } from '../buttons';
import { LoadingButtonProps } from '../buttons/LoadingButton';

export enum RewriteOption {
  IMPROVE_WRITING = 'improve',
  MAKE_LONGER = 'longer',
  MAKE_SHORTER = 'shorter',
  MORE_FRIENDLY = 'friendly',
  MORE_PROFESSIONAL = 'professional',
}

const AI_EDIT_OPTIONS = [
  {
    option: RewriteOption.IMPROVE_WRITING,
    label: 'Improve Writing',
    icon: <ConstellationIcon />,
  },
  {
    option: RewriteOption.MAKE_LONGER,
    label: 'Make Longer',
    icon: <ParagraphLongIcon />,
  },
  {
    option: RewriteOption.MAKE_SHORTER,
    label: 'Make Shorter',
    icon: <ParagraphShortIcon />,
  },
  {
    option: RewriteOption.MORE_FRIENDLY,
    label: 'More Friendly',
    icon: <SmileIcon />,
  },
  {
    option: RewriteOption.MORE_PROFESSIONAL,
    label: 'More Professional',
    icon: <OfficeBuildingIcon />,
  },
];

type AIEditOptionsProps = {
  isLoadingOption?: RewriteOption;
  onClick: (option: RewriteOption) => Promise<unknown>;
} & Omit<LoadingButtonProps, 'onClick' | 'loading'>;

const AIEditOptions: React.FC<AIEditOptionsProps> = ({
  onClick,
  isLoadingOption,
  ...props
}) =>
  AI_EDIT_OPTIONS.map(({ option, label, icon }) => (
    <LoadingButton
      key={option}
      color={'softGold'}
      onClick={() => onClick(option)}
      startIcon={icon}
      loading={isLoadingOption === option}
      {...props}
    >
      {label}
    </LoadingButton>
  ));

export default AIEditOptions;
